<mat-calendar
  [selected]="selection || ''"
  [startAt]="selection"
  (selectedChange)="updateSelection($event)"></mat-calendar>
